import { Info, Label, Tooltip } from '@chain-zen/ui'

interface LabelRowProps {
  children: React.ReactNode
  label: string
  tooltipText?: string
}

export const LabelRow = ({ label, tooltipText, children }: LabelRowProps) => {
  return (
    <div className="grid grid-cols-2 items-center space-x-4">
      <div className="flex space-x-2">
        <Label>{label}</Label>
        {!!tooltipText && (
          <Tooltip delay={500} content={tooltipText}>
            <Info className="h-4 w-4 text-muted-foreground cursor-help" />
          </Tooltip>
        )}
      </div>
      <div>{children}</div>
    </div>
  )
}
